<template>
  <PublicLayout :account="account" :settings="settings.data || {}" @logout="logout">
    <router-view v-slot="{ Component }"><component :is="Component" :settings-state="settings" @retry-settings="loadSettings" /></router-view>
  </PublicLayout>
</template>
<script>
import PublicLayout from '@/components/layouts/PublicLayout.vue';
import { settingsData } from '@/api/settings';
import { resource, loadResource } from './content';
export default {
  name: 'PublicSite', components: { PublicLayout }, data: () => ({ settings: resource() }),
  computed: {
    account() {
      if (!this.$store.getters.isAuthenticated) return null;
      const profile = this.$store.getters.profile;
      return { name: profile.name || this.$t('ui.profile'), email: profile.email || '' };
    }
  },
  created() { this.loadSettings(); },
  methods: {
    loadSettings() { return loadResource(this.settings, settingsData, 'settings'); },
    async logout() { await this.$store.dispatch('logout'); window.location.assign('/login'); }
  }
};
</script>
